/**
 * Turn a stored note's LITERAL `\r\n` / `\n` escapes into real newlines, for anywhere a
 * note is put into a textarea for editing — notes come back from the backend with the
 * escapes as text. `formatBreakNote` below is the display variant (collapses them to
 * commas for a single grid cell). Every place that seeds a note control must apply
 * this, or the same break renders differently depending on which dialog opened it.
 *
 * NoteEditorComponent.cleanNote deliberately keeps its own copy of the regex: it
 * returns `(string | undefined)[]` and that `undefined` feeds setInitialNoteValue's
 * shared-note comparison. So grepping callers here will not show the hold/accept path.
 */
export function unescapeNoteNewlines(note: string | undefined): string {
  return (note ?? '').replace(/(\\r\\n)|(\\n)/g, '\n')
}

/**
 * Format a note to be displayed in the UI
 */
export function formatBreakNote(note?: string, isGrid?: boolean) {
  // Values are coming back with double back slashes (\\).
  // This regex finds and replaces them with a comma.
  const formatted = note != null ? note.replace(/(\\r\\n)|(\\n)/g, ', ') : ''
  if (isGrid) {
    return formatted.replace(/(\r\n|\n)/g, ' ')
  }

  return formatted
}
